import {get} from '../utils'
import {getActiveClient} from "../authentication/utils";

export default host => (reelId, include = '') =>
  get(`${host}/user/reel/${reelId}?include=userFiles.video.thumbnail&${include}`)
  .then(response => response.json())
  .then(response => response.data)